import { shouldPolyfill } from "@formatjs/intl-locale/should-polyfill";

export async function polyfillIntlLocale() {
  if (shouldPolyfill()) {
    await import("@formatjs/intl-locale/polyfill");
  }
}
